import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_1.jpg';
import projectImage2 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/industrial-hazard-recognition/IndustrialHazardRecognition_Slider_6.jpg';

import Data_IndustrialHazardRecognitionProgram from './Data_IndustrialHazardRecognitionProgram';

function Work_IndustrialHazardRecognitionProgram() {
    return (
        <>
            <DetailedHeader
                heading="Building Real-World Readiness in Hazardous Environments"
                client="NORCAT (Internal)"
                service="Virtual Reality"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=ClBHO6a_ROc"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Industrial hazard recognition training simulation',
                    },
                    {
                        image: projectImage2,
                        alt: 'Industrial hazard recognition training simulation',
                    },
                    {
                        image: projectImage3,
                        alt: 'Industrial hazard recognition training simulation',
                    },
                    {
                        image: projectImage4,
                        alt: 'Industrial hazard recognition training simulation',
                    },
                    {
                        image: projectImage5,
                        alt: 'Industrial hazard recognition training simulation',
                    },
                    {
                        image: projectImage6,
                        alt: 'Industrial hazard recognition training simulation',
                    },
                ]}
            />

            {Data_IndustrialHazardRecognitionProgram.content}
        </>
    );
}

export default Work_IndustrialHazardRecognitionProgram;
